var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_56_x2C__Box_x2C__Delivery_x2C__Open_x2C__Package_x2C__Parcel_x2C_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m460.143 156.002 42.929-42.929c4.89-4.892 3.447-13.154-2.79-16.109l-190-90c-3.82-1.809-8.364-1.022-11.353 1.966l-42.929 42.93-42.928-42.929c-2.988-2.988-7.531-3.775-11.353-1.966l-190 90c-6.249 2.96-7.673 11.226-2.79 16.109l42.929 42.929-42.929 42.928c-4.891 4.891-3.448 13.154 2.79 16.109l44.281 20.975v159.987c0 3.713 2.057 7.12 5.342 8.85.867.456 189.513 99.749 190.132 100.059 2.762 1.409 6.114 1.512 9.183-.059-7.444 3.919 182.658-96.136 190-100 3.286-1.729 5.343-5.137 5.343-8.85v-159.987l44.281-20.975c6.251-2.961 7.67-11.227 2.79-16.109zm-204.143 78.935-166.64-78.935 166.64-78.934 166.639 78.934zm52.088-206.88 170.808 80.909-34.983 34.983-170.809-80.909zm-104.175 0 34.982 34.983-170.807 80.908-34.983-34.983zm-135.825 140 170.807 80.909-34.982 34.983-170.808-80.909zm7.913 77.432 125.719 59.55c3.833 1.816 8.377 1.01 11.353-1.966l32.927-32.928v209.294l-170-89.474v-144.476zm359.999 144.476-170 89.474v-209.294l32.929 32.929c2.977 2.977 7.522 3.781 11.353 1.966l125.718-59.551zm-127.912-106.017-34.983-34.983 170.808-80.909 34.983 34.983z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.abe76ba4454ceb3a95ee0452e605e13c.svg";
export { ForwardRef as ReactComponent };